import { isEmpty } from 'lodash';
import { useIntl } from 'react-intl';

import { Loader } from '@/components';

import { processClassOverviewData, type ClassOverviewProps } from './ClassOverview.data';
import ClassOverviewView from './ClassOverview.view';

const ClassOverview = ({
    isLoading = true,
    course,
    classroom,
    instructors,
    provider,
    learningActivity,
}: ClassOverviewProps) => {
    const { locale, formatMessage } = useIntl();

    const shouldShowContent = !isLoading && !isEmpty(classroom);

    return (
        <Loader isLoading={isLoading || isEmpty(classroom)}>
            {shouldShowContent && (
                <ClassOverviewView
                    data={processClassOverviewData(
                        { course, classroom, instructors, provider, learningActivity },
                        formatMessage,
                        locale,
                    )}
                />
            )}
        </Loader>
    );
};

export default ClassOverview;
